"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.format = exports.DEFAULT_DATE_FORMAT = undefined;

var _DateFormat = require("./DateFormat");

var _DateFormat2 = _interopRequireDefault(_DateFormat);

var _DateFormatFuzzy = require("./DateFormatFuzzy");

var _DateFormatFuzzy2 = _interopRequireDefault(_DateFormatFuzzy);

var _DateFormatRange = require("./DateFormatRange");

var _DateFormatRange2 = _interopRequireDefault(_DateFormatRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = "MMM D YYYY";

// a default set of formatters. These are `required` rather than imported in-case there is a cyclic dependency
// between any of the formatters and the main format.
var defaultFormatters = function defaultFormatters() {
    return [require("./DateFormat").default, require("./DateFormatRange").default, require("./DateFormatFuzzy").default];
};

/**
 * Format a date.
 *
 * @param value {Any} the value to format.
 * @param [format] {String} the string format.
 * @param [opts] {Object} the options object.
 *   @param [opts.formatters] {Array} an array of formatters to use (in order)
 *   @param [opts.utc] {boolean} force UTC date handling.
 * @return {String} the formatted date.
 */
var format = exports.format = function format(value, _format, opts) {
    var result = "";

    if (typeof _format !== "string") {
        opts = _format;
        _format = DEFAULT_DATE_FORMAT;
    }

    opts || (opts = {});

    // iterate over formatters until we find a result.
    var formatters = opts.formatters || (opts.formatters = defaultFormatters());
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = formatters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var formatter = _step.value;

            result = formatter(value, _format, opts);
            if (result) {
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
};
//# sourceMappingURL=format.js.map